var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCentaurFlowerCirc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A2CCC161-D9B3-4778-B240-6FA5DB6C516C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      fill: "#fff",
      strokeWidth: 1.7452
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0127 5.6177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.138 11.898h-6.6069c-3.3658 0-5.9837 2.8907-5.9837 5.75h6.3576c3.4281 0 6.233-2.4843 6.233-5.75z",
    fill: "#363335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4-Copy",
    d: "m15.139 8.9171h-3.3689c-1.7162 0-3.0511 1.4768-3.0511 2.9375h3.2418c1.748 0 3.1782-1.2691 3.1782-2.9375z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m8.7193 11.784c0.06784-3.7471 3.4482-7.4971 7.8053-7.5717l0.13233-0.0011h8.7657c0 4.3225-3.6472 7.621-8.1333 7.6865l-0.1362 9.94e-4h-5.1931c1.748 0 3.1782-1.2691 3.1782-2.9375h-3.3689c-1.6991 0-3.0243 1.4474-3.0507 2.8937z",
    fill: "#e56e4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.0977 1.1484c2.331 0 4.683 1.7542 5.4639 4.2383-2.3228 1.4344-3.8434 3.9822-3.8434 6.5117l-0.0097 1.36e-4c-0.99551-1.1183-1.5988-2.6451-1.6107-4.3242l-1.82e-4 -0.05093z",
    fill: "#d23239"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentaurFlowerCirc);
export default __webpack_public_path__ + "static/media/centaur_flower_circ.ae8c4a882339a82e111b74a74fba4bc0.svg";
export { ForwardRef as ReactComponent };